if (!customElements.get('sw-sticky-buy')) {
  class SwStickyBuy extends HTMLElement {
    connectedCallback() {
      this.source = document.getElementById(this.dataset.buttonId);
      if (!this.source) return;

      this.button = this.querySelector('[data-sw-sticky-submit]');
      this.price = this.querySelector('[data-sw-sticky-price]');
      this.sourcePrice = this.closest('.sw-pdp')?.querySelector('[data-sw-price]');
      this.footer = document.querySelector('.shopify-section-group-footer-group, footer');

      this.button?.addEventListener('click', () => {
        if (!this.source.disabled) this.source.click();
      });

      this.sync = this.sync.bind(this);
      this.mirror = new MutationObserver(this.sync);
      this.mirror.observe(this.source, { attributes: true, childList: true, subtree: true, characterData: true });
      if (this.sourcePrice) {
        this.mirror.observe(this.sourcePrice, { childList: true, subtree: true, characterData: true });
      }
      this.sync();

      this.toggle = this.toggle.bind(this);
      this.observer = new IntersectionObserver(([entry]) => {
        this.toggle(entry.boundingClientRect.bottom < 0);
      }, { threshold: 0 });
      this.observer.observe(this.source);
      this.toggle(false);
    }

    disconnectedCallback() {
      this.mirror?.disconnect();
      this.observer?.disconnect();
      document.body.classList.remove('sw-has-sticky-buy');
    }

    toggle(passed) {
      const atFooter = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
      const show = passed && !atFooter;
      if (show === this.classList.contains('is-visible')) return;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.button?.setAttribute('tabindex', show ? '0' : '-1');
      document.body.classList.toggle('sw-has-sticky-buy', show);
    }

    sync() {
      if (this.button) {
        const label = this.source.querySelector('span')?.textContent.trim();
        if (label && this.button.textContent.trim() !== label) this.button.textContent = label;
        this.button.disabled = this.source.disabled;
        this.button.classList.toggle('is-loading', this.source.classList.contains('loading'));
      }
      if (this.price && this.sourcePrice) {
        const current = this.sourcePrice.firstChild?.textContent.trim() || this.sourcePrice.textContent.trim();
        if (current && this.price.textContent !== current) this.price.textContent = current;
      }
    }
  }

  customElements.define('sw-sticky-buy', SwStickyBuy);
}
